import { ChangeDetectionStrategy, Component, effect, inject, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryColorLabel, GalleryDto } from '@nusign/picflow-backend-types';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { defaultColorLabels } from '../../../configs/default-color-labels';
import { capitalize } from '../../../lib/capitalize';
import { debounce } from '../../../lib/debounce';
import { GalleryService } from '../../../services/gallery.service';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';
import { BillingScopePipe } from '../../../shared-extra/pipes/billing-scope.pipe';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-custom-color-labels-setting-item',
  imports: [
    AccessItemComponent,
    FormsModule,
    AccessItemBodyComponent,
    InputFieldComponent,
    SwitchComponent,
    CapitalizePipe,
    BillingScopePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './custom-color-labels-setting-item.component.html',
  styleUrl: './custom-color-labels-setting-item.component.scss',
})
export class CustomColorLabelsSettingItemComponent {
  galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  colorLabel = input.required<GalleryColorLabel>();
  labelName = model('');
  labelActive = model(false);

  constructor() {
    effect(() => {
      const label = this.colorLabel();

      if (defaultColorLabels.some(c => c.color === label.color && c.name === label.name)) {
        this.labelName.set('');
      } else {
        this.labelName.set(label.name);
      }
      this.labelActive.set(label.active);
    });
  }

  updateColorLabel() {
    const colorLabels = this.gallery().color_labels;
    const label = colorLabels.find(c => c.color === this.colorLabel().color);
    label.name = this.labelName() || capitalize(label.color);
    label.active = this.labelActive();

    this.galleryService.updateGallery(this.gallery(), {
      color_labels: colorLabels,
    });
  }

  updateColorLabelDebounced = debounce(() => {
    this.updateColorLabel();
  }, 500);
}
